import React from "react";
import {CollHeader} from "./styleComponentes";

export const CardHearder = ({icon, titulo, texto, subTitulo}) => {
    return(
        <CollHeader>
            <div>
                <span>{icon}</span>
                <div style={{fontSize: '12px'}}>{subTitulo ? subTitulo : 'MÓDULO'}</div>
            </div>
            <h2>{titulo}</h2>
            <p>
                {texto}
            </p>

            <div>
            </div>
        </CollHeader>
    )
};